/* Dave's Drum Shop · Stage 8 · collection and search infinite scrolling.
   Uses Shopify's native next-page URL. Filter/sort requests remain owned by the
   existing theme's CollectionSection. Native pagination remains the fallback.
*/
(function () {
  'use strict';

  if (window.__ddsInfiniteScrollInitialized) return;
  window.__ddsInfiniteScrollInitialized = true;

  var instances = new WeakMap();
  var reducedData = !!(navigator.connection && navigator.connection.saveData);

  function init(section) {
    var dynamic = section.querySelector('.collection__dynamic-part');
    if (!dynamic || instances.has(section)) return;
    var state = {
      section: section, dynamic: dynamic, observer: null, observerDOM: null,
      request: null, serial: 0, nextUrl: null, loading: false, finished: false,
      count: 0, total: 0, first: 1, active: false
    };
    instances.set(section, state);

    dynamic.addEventListener('click', function (event) {
      var button = event.target.closest('[data-dds-infinite-load]');
      if (!button || !dynamic.contains(button)) return;
      event.preventDefault();
      loadNext(state);
    });

    // The theme replaces .collection__dynamic-part with new HTML after changes
    // to sorting, filtering, display count, and browser history.
    state.observerDOM = new MutationObserver(function (records) {
      if (!records.some(function (r) {
        return Array.from(r.addedNodes).some(function (n) {
          return n.nodeType === 1 && (
            n.classList.contains('collection__toolbar') ||
            n.classList.contains('product-list') ||
            !!n.querySelector('.product-list--collection')
          );
        });
      })) return;
      reset(state);
    });
    state.observerDOM.observe(dynamic, {childList: true});
    reset(state);
  }

  function detach(state) {
    state.serial += 1;
    if (state.request) state.request.abort();
    state.request = null;
    if (state.observer) state.observer.disconnect();
    state.observer = null;
    state.loading = false;
    state.active = false;
    state.dynamic.classList.remove('dds-infinite-enabled');
  }

  function reset(state) {
    detach(state);
    var grid = state.dynamic.querySelector('.product-list--collection');
    var pager = state.dynamic.querySelector('.pagination');
    var ui = state.dynamic.querySelector('[data-dds-infinite-ui]');
    if (!grid || !pager || !ui) return;

    var next = pager.querySelector('.pagination__next[href]');
    if (!next) return; // Page 1 of 1: native rendering, nothing to load.

    var sourceUrl;
    try {
      sourceUrl = new URL(next.href, window.location.href);
    } catch (e) { return; }
    if (sourceUrl.origin !== window.location.origin) return;

    state.nextUrl = sourceUrl.href;
    state.grid = grid;
    state.ui = ui;
    state.button = ui.querySelector('[data-dds-infinite-load]');
    state.message = ui.querySelector('[data-dds-infinite-message]');
    state.status = ui.querySelector('[data-dds-infinite-status]');
    if (!state.button || !state.message || !state.status) return;
    state.total = Number(ui.getAttribute('data-total')) || 0;
    state.first = Number(ui.getAttribute('data-first')) || 1;
    state.count = grid.children.length;
    state.finished = false;
    state.active = true;
    ui.hidden = false;
    state.dynamic.classList.add('dds-infinite-enabled');
    update(state);

    if ('IntersectionObserver' in window && !reducedData) {
      state.observer = new IntersectionObserver(function (entries) {
        if (entries.some(function (entry) { return entry.isIntersecting; })) {
          loadNext(state);
        }
      }, {rootMargin: '380px 0px', threshold: 0});
      state.observer.observe(ui);
    }
  }

  function update(state) {
    var last = state.first + state.count - 1;
    var lang = document.documentElement.lang || 'en';
    var text = /^fr\b/i.test(lang)
      ? ('Articles ' + state.first + ' à ' + last + (state.total ? (' sur ' + state.total) : '') )
      : ('Showing ' + state.first + '–' + last + (state.total ? (' of ' + state.total) : '') + ' products');
    state.message.textContent = text;
    var oldLabel = state.dynamic.querySelector('.collection__products-count-showing');
    // This label is normally replaced by Shopify only after a filter changes.
    // Update it to reflect the actually displayed products when available.
    if (oldLabel) oldLabel.textContent = text;
    if (state.finished) {
      state.button.hidden = true;
      state.status.textContent = /^fr\b/i.test(lang) ? 'Tous les produits chargés.' : 'All products loaded.';
    } else if (!state.loading) {
      state.button.hidden = false;
      state.button.disabled = false;
      state.button.textContent = /^fr\b/i.test(lang) ? 'Charger plus de produits' : 'Load more products';
      state.status.textContent = '';
    }
  }

  async function loadNext(state) {
    if (!state.active || state.loading || state.finished || !state.nextUrl) return;
    var seq = state.serial;
    var currentGrid = state.grid;
    var currentUi = state.ui;
    // Native URLs include all active filter, sort, and page-size parameters.
    var next = new URL(state.nextUrl);
    if (next.origin !== window.location.origin || next.pathname !== window.location.pathname) return;

    state.loading = true;
    state.button.disabled = true;
    state.button.textContent = /^fr\b/i.test(document.documentElement.lang || '') ? 'Chargement…' : 'Loading…';
    state.status.textContent = '';
    if (state.observer) state.observer.disconnect();
    state.request = new AbortController();
    try {
      // Shopify Section Rendering returns only the collection/search section.
      next.searchParams.set('section_id', state.section.getAttribute('data-section-id'));
      var response = await fetch(next.href, {
        method: 'GET', credentials: 'same-origin',
        headers: {'X-Requested-With': 'XMLHttpRequest'},
        signal: state.request.signal
      });
      if (!response.ok) throw new Error('Could not load the next page (' + response.status + ')');
      var html = await response.text();
      if (seq !== state.serial || currentGrid !== state.grid || currentUi !== state.ui ||
          !state.section.isConnected) return;
      var page = new DOMParser().parseFromString(html, 'text/html');
      var newGrid = page.querySelector('.collection__dynamic-part .product-list--collection');
      var nextPager = page.querySelector('.collection__dynamic-part .pagination');
      if (!newGrid) throw new Error('Shopify did not return any product grid');
      var products = Array.from(newGrid.children);
      if (!products.length) throw new Error('Shopify returned no more products');

      // Keep the exact active list/grid view in case the customer changed it.
      var reference = currentGrid.querySelector('.product-item');
      var listView = !!(reference && reference.classList.contains('product-item--list'));
      products.forEach(function (product) {
        if (product.classList.contains('product-item') && reference) {
          if (listView) product.className = 'product-item product-item--list';
          else product.className = reference.className;
        }
        currentGrid.appendChild(document.adoptNode(product));
      });
      state.count += products.length;
      var nextLink = nextPager && nextPager.querySelector('.pagination__next[href]');
      state.nextUrl = nextLink ? new URL(nextLink.getAttribute('href'), state.nextUrl).href : null;
      state.finished = !state.nextUrl || (state.total > 0 && state.first + state.count - 1 >= state.total);
      if (state.finished && state.observer) {
        state.observer.disconnect();
        state.observer = null;
      }
      state.loading = false;
      state.request = null;
      state.dynamic.classList.add('dds-infinite-enabled');
      update(state);
      // Announce appended content for other theme/app listeners if needed.
      state.section.dispatchEvent(new CustomEvent('dds:products-appended', {
        bubbles: true, detail: {count: products.length, nextUrl: state.nextUrl}
      }));
      if (!state.finished && state.observer) state.observer.observe(state.ui);
    } catch (error) {
      if (seq !== state.serial || (error && error.name === 'AbortError')) return;
      state.loading = false;
      state.request = null;
      state.button.disabled = false;
      state.button.textContent = /^fr\b/i.test(document.documentElement.lang || '') ? 'Réessayer' : 'Retry loading';
      state.status.textContent = /^fr\b/i.test(document.documentElement.lang || '')
        ? 'Impossible de charger les produits. Utilisez la pagination ci-dessous.'
        : 'Could not load more products. Use the page links below or retry.';
      // Page links are always present in the Liquid markup as a non-JS fallback.
      state.dynamic.classList.remove('dds-infinite-enabled');
      if (state.observer) state.observer.disconnect();
      state.observer = null;
    }
  }

  function boot() {
    document.querySelectorAll('section[data-section-type="collection"][data-section-id]')
      .forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
